import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`
        sticky top-0 z-20 transition-all duration-300
        ${scrolled
          ? "bg-gradient-to-l from-blue-500 to-white shadow-md backdrop-saturate-150"
          : "bg-transparent"
        }
      `}
      role="navigation"
      aria-label="Primary"
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Left: Logo */}
        <Link to="/" className="flex-shrink-0" aria-label="MM AutoTech home">
          <img
            src="/logo.svg"
            alt="MM AutoTech logo"
            className="h-16 w-auto"
            width="160"
            height="64"
            loading="eager"
            decoding="async"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex gap-8 text-blue-900 font-medium text-lg">
          <li>
            <NavLink to="/" end>
              Home
            </NavLink>
          </li>

          {/* Services Dropdown */}
          <li className="relative group">
            <NavLink to="/services" className="flex items-center gap-1">
              <span>Services</span>
              <span aria-hidden="true">▾</span>
            </NavLink>

            <ul className="absolute hidden group-hover:block top-full left-0 mt-1 w-72 bg-white shadow-md rounded py-4 px-6 max-h-72 overflow-y-auto">
              <li><NavLink to="/services/business-support">Business Support</NavLink></li>
              <li><NavLink to="/services/garage-software-setup">Garage Software Setup</NavLink></li>
              <li><NavLink to="/services/digital-marketing">Digital Marketing</NavLink></li>
              <li><NavLink to="/services/parts-procurement">Parts Procurement</NavLink></li>
              <li><NavLink to="/services/leads-generation">Leads Generation</NavLink></li>
              <li><NavLink to="/services/customer-services">Customer Services</NavLink></li>
              <li><NavLink to="/services/road-assistance">Road Assistance</NavLink></li>
              <li><NavLink to="/services/vehicle-recovery">Vehicle Recovery</NavLink></li>
              <li><NavLink to="/services/sale-purchase">Sale/Purchase of Cars</NavLink></li>
            </ul>
          </li>

          <li><NavLink to="/book-appointment">Book Appointment</NavLink></li>
          <li><NavLink to="/contact">Contact</NavLink></li>
          <li><NavLink to="/about">About</NavLink></li>
          <li><NavLink to="/blog">Blog</NavLink></li> {/* 👈 Added Blog */}
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-blue-900 focus:outline-none text-2xl"
          aria-label="Toggle menu"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <ul className="flex flex-col gap-4 p-6 text-blue-900 font-medium">
            <li>
              <NavLink to="/" onClick={() => setMenuOpen(false)}>
                Home
              </NavLink>
            </li>

            {/* Mobile Accordion for Services */}
            <li>
              <div className="flex justify-between items-center">
                <NavLink
                  to="/services"
                  onClick={() => setMenuOpen(false)}
                  className="flex-1"
                >
                  Services
                </NavLink>
                <button
                  onClick={() => setServicesOpen(!servicesOpen)}
                  className="ml-2 focus:outline-none"
                >
                  {servicesOpen ? "▴" : "▾"}
                </button>
              </div>

              {servicesOpen && (
                <ul className="pl-4 mt-2 flex flex-col gap-2 text-blue-700">
                  <li><NavLink to="/services/business-support" onClick={() => setMenuOpen(false)}>Business Support</NavLink></li>
                  <li><NavLink to="/services/garage-software-setup" onClick={() => setMenuOpen(false)}>Garage Software Setup</NavLink></li>
                  <li><NavLink to="/services/digital-marketing" onClick={() => setMenuOpen(false)}>Digital Marketing</NavLink></li>
                  <li><NavLink to="/services/parts-procurement" onClick={() => setMenuOpen(false)}>Parts Procurement</NavLink></li>
                  <li><NavLink to="/services/leads-generation" onClick={() => setMenuOpen(false)}>Leads Generation</NavLink></li>
                  <li><NavLink to="/services/customer-services" onClick={() => setMenuOpen(false)}>Customer Services</NavLink></li>
                  <li><NavLink to="/services/road-assistance" onClick={() => setMenuOpen(false)}>Road Assistance</NavLink></li>
                  <li><NavLink to="/services/vehicle-recovery" onClick={() => setMenuOpen(false)}>Vehicle Recovery</NavLink></li>
                  <li><NavLink to="/services/sale-purchase" onClick={() => setMenuOpen(false)}>Sale/Purchase of Cars</NavLink></li>
                </ul>
              )}
            </li>

            <li><NavLink to="/blog" onClick={() => setMenuOpen(false)}>Blog</NavLink></li> {/* 👈 Added Blog */}
            <li><NavLink to="/book-appointment" onClick={() => setMenuOpen(false)}>Book Appointment</NavLink></li>
            <li><NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink></li>
            <li><NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink></li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
